module.exports = __webpack_public_path__ + "img/hb.49d287f9.png";